import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import {
  deleteStudyBudgetVisit,
  clearStudyBudgetVisitAction
} from "actions/studies/studyBudgetVisitActions";

const StudyBudgetVisitDelete = ({ formId, closeModal, selected }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearStudyBudgetVisitAction());
    };
  }, [dispatch]);

  const handleDelete = e => {
    e.preventDefault();
    dispatch(deleteStudyBudgetVisit(selected));
    closeModal();
  };

  return (
    <form
      id={formId}
      onSubmit={e => handleDelete(e)}
      className="form container"
    >
      <div className="font-weight-light">
        Are you sure you want to delete this study budget visit? This can not be
        undone.
      </div>
    </form>
  );
};

export default StudyBudgetVisitDelete;
